/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGetAward.vue?vue&type=template&id=20686ac4&scoped=true"
import script from "./popGetAward.vue?vue&type=script&lang=js"
export * from "./popGetAward.vue?vue&type=script&lang=js"
import style0 from "./popGetAward.vue?vue&type=style&index=0&id=20686ac4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20686ac4",
  null
  
)

export default component.exports